define('views/content/wallet_histories',['require','views/base/list_page_view','views/components/wallet_history/wallet_histories','collections/wallet_histories','text!templates/content/wallet_histories.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var WalletHistoriesView = require('views/components/wallet_history/wallet_histories');
    var WalletHistoriesCollection = require('collections/wallet_histories');

    var temp = require("text!templates/content/wallet_histories.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'wallet-history-page',
        titleKey: 'wallet_histories',

        setCollection: function () {
            this.collection = new WalletHistoriesCollection();
        },

        onRender: function() {
            this.ListContainer.show(new WalletHistoriesView({
                collection: this.collection
            }));
        }

    });
});
